import { render, staticRenderFns } from "./DownloadBox.vue?vue&type=template&id=04bf001a&scoped=true&"
import script from "./DownloadBox.vue?vue&type=script&lang=js&"
export * from "./DownloadBox.vue?vue&type=script&lang=js&"
import style0 from "./DownloadBox.vue?vue&type=style&index=0&id=04bf001a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bf001a",
  null
  
)

export default component.exports